////// Doc. //////
//////////////////

// Initialises the slideshow fallback overlay for the VideoPlayer component.
// Cycles through a set of images above the video until playback begins —
// used as a visual fallback when browser autoplay policy blocks muted video.

////// Lib. //////
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. slideshow"],
  end: ["init. slideshow", "init. success"],
  no_el: ["init. slideshow", "no slide elements found — skipping"],
  no_pl: ["init. slideshow", "no player instance — skipping"],
  playing: ["init. slideshow", "video playing — stopping slideshow"],
  stopped: ["slideshow", "stopped"],
};

// Method def. ///
//////////////////

export default function init_slideshow() {
  ///// Setup //////
  //////////////////

  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  const slides = this.ref.slideEl;
  if (!slides || slides.length === 0) {
    if (logs) console.log(...msgs.no_el);
    return;
  }

  if (!this.player) {
    if (logs) console.log(...msgs.no_pl);
    return;
  }

  // Attach helper methods onto the instance so the component class stays clean.
  this.next_slide = next_slide.bind(this);
  this.stop_slideshow = stop_slideshow.bind(this);
  this.destroy_slideshow = destroy_slideshow.bind(this);

  ///// Action /////
  //////////////////

  this.slideshow = { index: 0, timer: null };

  // Show the first slide immediately.
  slides[0].classList.remove("opacity-0");
  slides[0].classList.add("opacity-100");

  // Cycle through remaining slides on an interval.
  if (slides.length > 1) {
    this.slideshow.timer = setInterval(() => this.next_slide(), this.options.slideDuration);
  }

  // Stop the slideshow only when the video is genuinely playing.
  // Safari fires `playing` transiently then immediately pauses when autoplay
  // is blocked — `timeupdate` only fires once currentTime has actually advanced,
  // so it's the reliable signal that playback is truly underway.
  const onTruePlay = () => {
    if (this.player.currentTime() > 0 && !this.player.paused()) {
      this.player.off("timeupdate", onTruePlay);
      if (logs) console.log(...msgs.playing);
      this.stop_slideshow();
    }
  };
  this.player.on("timeupdate", onTruePlay);
  // Store the handler so destroy_slideshow can clean it up if unmount fires first.
  this.slideshow.offTruePlay = () => this.player.off("timeupdate", onTruePlay);

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1], `(${slides.length} slide(s))`);
}

//// Helpers /////
//////////////////

function next_slide() {
  const slides = this.ref.slideEl;
  const prev = this.slideshow.index;
  const next = (prev + 1) % slides.length;

  slides[prev].classList.remove("opacity-100");
  slides[prev].classList.add("opacity-0");
  slides[next].classList.remove("opacity-0");
  slides[next].classList.add("opacity-100");

  this.slideshow.index = next;
}

function stop_slideshow() {
  if (!this.slideshow) return;

  clearInterval(this.slideshow.timer);
  this.slideshow.timer = null;

  const container = this.ref.slideshowEl;
  if (!container) return;

  // Fade out the overlay; hide it from layout after the transition completes.
  // setTimeout fallback covers prefers-reduced-motion (transition may not fire).
  container.classList.add("opacity-0");
  setTimeout(() => (container.hidden = true), 750);
  if (this.options.logs) console.log(...msgs.stopped);
}

function destroy_slideshow() {
  if (this.slideshow?.timer) clearInterval(this.slideshow.timer);
  this.slideshow?.offTruePlay?.();
  this.slideshow = null;
}
